import type { FC } from 'react';

import { ModalError } from 'Features/SellerCommunications/components/ModalError';
import { enquirySelectionService } from 'Features/SellerCommunications/services';
import { T } from 'Features/SellerCommunications/utils/translate';
import { triggerSellerMessagingLoadingVehicleFailedTryAgainButtonClickedEvent } from 'Services/analytics/events';

export const EnquirySelectionError: FC = () => {
	const onActionClick = () => {
		enquirySelectionService.onRefetchCommunicationData();
		triggerSellerMessagingLoadingVehicleFailedTryAgainButtonClickedEvent();
	};

	return (
		<ModalError
			action={T.translate('enquiryList.errorAction')}
			description={T.translate('enquiryList.errorDescription')}
			onActionClick={onActionClick}
			title={T.translate('enquiryList.errorTitle')}
		/>
	);
};
